import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { environment } from 'src/environments/environment';
import { initialMarginNotesSlice } from './margin-notes.slice';
import { MarginNotes } from '../../models/margin-notes.model';

export const MarginNotesStore = signalStore(
    { providedIn: 'root' },
    withState(initialMarginNotesSlice),
    withComputed((store) => ({
        snapshot: computed(() => ({
            marginNotes: store.marginNotes()
        }))
    })),
    withMethods((store) => ({
        updateMarginNotes: (data: Partial<MarginNotes>) => {
            patchState(store, { ...data });
        },
        getState: () => store,
        getSnapshot: () => store.snapshot()
    })),
    environment.storeWithDevTools('locums-margin-calculator-margin-notes-store')
);
